export { default } from './ManagedAccountPageInfoBar';
